// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '../../app.js';
import * as Plugin_1 from '/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/.umi-production/plugin-dva/runtime.tsx';
import * as Plugin_2 from '../plugin-model/runtime';
import * as Plugin_3 from '@@/plugin-qiankun/slaveRuntimePlugin';
import * as Plugin_4 from '/home/jenkins/workspace/ansible-ui/route-forecast-ui/node_modules/umi-plugin-antd-icon-config/lib/app.js';

  plugin.register({
    apply: Plugin_0,
    path: '../../app.js',
  });
  plugin.register({
    apply: Plugin_1,
    path: '/home/jenkins/workspace/ansible-ui/route-forecast-ui/src/.umi-production/plugin-dva/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_2,
    path: '../plugin-model/runtime',
  });
  plugin.register({
    apply: Plugin_3,
    path: '@@/plugin-qiankun/slaveRuntimePlugin',
  });
  plugin.register({
    apply: Plugin_4,
    path: '/home/jenkins/workspace/ansible-ui/route-forecast-ui/node_modules/umi-plugin-antd-icon-config/lib/app.js',
  });

export const __mfsu = 1;
